module.exports = __webpack_public_path__ + "static/img/1489_phase_function_Paper_Points.39b34fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1489_phase_function_Paper_Points.png
// module id = W9lV
// module chunks = 0